import { render, staticRenderFns } from "./GamesTab.vue?vue&type=template&id=19d7867c&"
import script from "./GamesTab.vue?vue&type=script&lang=js&"
export * from "./GamesTab.vue?vue&type=script&lang=js&"
import style0 from "./GamesTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GamesTab.vue"
export default component.exports